import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import SharingIcon from "images/bSharing.svg";

import Collaborators from "components/UnifiedProject/Collaborators/Collaborators";

import * as projectReducer from "containers/Project/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as loginReducer from "containers/Login/reducer";

class CollaboratorsContainer extends React.Component {
  state = {
    show: false
  };

  handleClick(e, override) {
    const { onClick } = this.props;
    if (onClick) {
      return onClick();
    }
    return this.setState({ show: override !== undefined ? override : !this.state.show });
  }

  render() {
    const {} = this.props;

    return (
      <React.Fragment>
        <Collaborators {...this.props} show={this.state.show} onClick={(e) => this.handleClick(e)} />
        <Button
          type={"secondary"}
          active={this.state.show}
          onClick={(e) => this.handleClick(e)}
          style={{ padding: "6px" }}
        >
          <img src={SharingIcon} />
        </Button>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;
  return {
    addUserRoleToSegment: (segmentId, userId, role) =>
      dispatch(projectReducer.addUserRoleToSegment(id, segmentId, userId, role)),
    deleteUserRoleFromSegment: (segmentRoleId) => dispatch(projectReducer.deleteUserRoleFromSegment(id, segmentRoleId)),
    deleteUserFromProject: (userId, segmentId) => dispatch(projectReducer.deleteUserFromProject(id, userId, segmentId)),
    patchUserRoleSegment: (segmentRoleId, role) =>
      dispatch(projectReducer.patchUserRoleSegment(id, segmentRoleId, role)),
    updateProjectSetting: (key, val) => dispatch(projectReducer.updateProjectSetting(id, key, val))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  return {
    project: projectReducer.getProject(state, id),
    userName: loginReducer.getUserName(state),
    userId: loginReducer.getUserID(state),
    users: adminReducer.getUsers(state),
    isLoadingSharing: projectReducer.getIsLoadingSharing(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CollaboratorsContainer);
